import { useQuery } from '@tanstack/react-query';
import type { DocumentYears } from '@kontor/shared';
import { api } from '../api';
import './yearfilter.css';

/** Wert der Adresse für „alle Jahre“. Ohne Angabe gilt das laufende Jahr. */
export const ALL_YEARS = 'alle';

/** Das Jahr der Liste aus dem Parameter der Adresse: ohne Angabe das laufende Jahr, „alle“ ergibt undefined (kein Filter) */
export function yearOf(param: string | null): string | undefined {
  if (param === ALL_YEARS) return undefined;
  return param && /^\d{4}$/.test(param) ? param : String(new Date().getFullYear());
}

/**
 * Festes Filterfeld „Jahr“ neben der Suche einer Belegliste. Vorgabe ist das laufende Jahr. Zur Auswahl stehen die Jahre vom frühesten bis zum spätesten Beleg (vom Server),
 * dazu das laufende Jahr, damit die Vorgabe immer wählbar ist, und „Alle Jahre“. Der Wert steht in der Adresszeile (?jahr=2025), so bleibt er beim Neuladen erhalten.
 */
export function YearFilter({ endpoint, queryKey, value, onChange }: { endpoint: string; queryKey: string; value: string | null; onChange: (value: string) => void }) {
  const years = useQuery({ queryKey: [queryKey, 'years'], queryFn: async () => (await api<{ data: DocumentYears }>('GET', endpoint)).data, staleTime: 60_000 });
  const current = new Date().getFullYear();
  const first = Math.min(years.data?.first ?? current, current);
  const last = Math.max(years.data?.last ?? current, current);
  const list = Array.from({ length: last - first + 1 }, (_, i) => String(last - i));
  const selected = yearOf(value) ?? ALL_YEARS;
  // Ein Jahr aus der Adresse, das nicht in der Liste steht (zum Beispiel aus einem alten Link), bleibt sichtbar
  const options = selected !== ALL_YEARS && !list.includes(selected) ? [selected, ...list] : list;
  return (
    <label className="year-filter">
      <span>Jahr</span>
      <select className="input" value={selected} onChange={(e) => onChange(e.target.value)} aria-label="Jahr der Belege">
        {options.map((y) => <option key={y} value={y}>{y}</option>)}
        <option value={ALL_YEARS}>Alle Jahre</option>
      </select>
    </label>
  );
}
